<script lang="ts">
export default {
  name: 'KkUpgradeModal',
}
</script>
<script setup lang="ts" >
import { useI18n } from 'vue-i18n'
import { KkModal, KkButton, KkSiteIcon, KkIcon } from '../../../../components/base'
import { camelCase } from '../../../../modules/string_converter'
const { t } = useI18n()
interface Props {
  isVisible: boolean
  siteType: string

}
const props = defineProps<Props>()
const emit = defineEmits(['submit', 'close'])
</script>

<template>
  <KkModal :is-visible="props.isVisible" width="1076px" @change="emit('close')">
    <div class="p-modal__content__header">
      {{ t('pages.LocationStoreConnects.upgradeModal.title') }}
    </div>
    <div class="p-modal__content__body">
      <div class="upgradeModal__header">
        <div class="upgradeModal__icon">
          <KkSiteIcon :name="props.siteType" />
        </div>
        <div class="upgradeModal__title">
          {{ t(`labels.sites.${camelCase(props.siteType)}`) }}
        </div>
      </div>
      <div>
        {{ t('pages.LocationStoreConnects.upgradeModal.description') }}
      </div>
      <div class="upgradeModal__note">
        {{ t('pages.LocationStoreConnects.upgradeModal.note', { service: t(`labels.sites.${camelCase(props.siteType)}`) }) }}
      </div>
      <div class="upgradeModal__image">
        <KkIcon name="upgradeConversion" />
      </div>
    </div>
    <div class="p-modal__content__footer">
      <div class="c-button c-button--right">
        <span class="upgradeModal__caution">
          {{ t('pages.LocationStoreConnects.upgradeModal.caution') }}
        </span>
        <KkButton
          class="footerCancelBtn"
          color="secondary"
          outlined
          :text="t('labels.cancel')"
          @click="emit('close')"
        />
        <KkButton
          color="primary"
          outlined
          :text="t('pages.LocationStoreConnects.upgradeModal.submit')"
          @click="emit('submit')"
        />
      </div>
    </div>
  </KkModal>
</template>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.upgradeModal {
  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  &__title {
    margin-left: 16px;
    font-size: 20px;
    font-weight: bold;
  }

  &__icon {
    width: 64px;
    height: 64px;
    padding: 8px;
    border: 1px solid #E4E7EB;
    border-radius: 4px;
  }

  &__note {
    margin: 16px 0;
    font-size: 12px;
    opacity: 0.5;
  }

  &__image {
    img {
      width: 100%;
      height: 100%;
    }
  }

  &__caution {
    margin-right: auto;
    color: $color-accent-primary;
  }
}

.footerCancelBtn {
  margin-right: 8px;
}
</style>
